import React, { Component } from 'react';
import './ProfilePackages.css';

// Static package showcase (Buy disabled until packages go live)
class ProfilePackages extends Component {
  render() {
    return (
      <div className="profile-packages">
        <p className="profile-packages-intro">
          Choose how you unlock LED scroller video exports. Designing and live preview stay free —
          you only pay when you need to download.
        </p>

        <div className="profile-packages-grid">
          <article className="profile-pkg-card">
            <div className="profile-pkg-glow profile-pkg-glow-basic" aria-hidden="true" />
            <p className="profile-pkg-eyebrow">Single export</p>
            <h2 className="profile-pkg-name">Video Export</h2>
            <p className="profile-pkg-tagline">
              Perfect when you need one finished LED video for a shop screen, event, or post.
            </p>
            <div className="profile-pkg-price-row">
              <span className="profile-pkg-price">$1.49</span>
              <span className="profile-pkg-price-note">one-time</span>
            </div>
            <ul className="profile-pkg-features">
              <li>1 LED scroller video download</li>
              <li>Instant unlock after secure checkout</li>
              <li>Order ID + Access Code recovery</li>
              <li>Up to 5 re-downloads · 30 days</li>
              <li>Design &amp; preview remain free</li>
            </ul>
            <button type="button" className="profile-pkg-buy" disabled>
              Coming soon
            </button>
          </article>

          <article className="profile-pkg-card profile-pkg-card-pro">
            <div className="profile-pkg-glow profile-pkg-glow-pro" aria-hidden="true" />
            <span className="profile-pkg-ribbon">Best value</span>
            <p className="profile-pkg-eyebrow">Creator pack</p>
            <h2 className="profile-pkg-name">Pro Export Pack</h2>
            <p className="profile-pkg-tagline">
              Built for creators who export often — more downloads in one purchase, same LED quality.
            </p>
            <div className="profile-pkg-price-row">
              <span className="profile-pkg-price">$5.99</span>
              <span className="profile-pkg-price-note">one-time</span>
            </div>
            <ul className="profile-pkg-features">
              <li>5 LED scroller video exports</li>
              <li>Save vs buying singles</li>
              <li>Shared Order ID recovery tools</li>
              <li>Extended re-download window</li>
              <li>Design &amp; preview remain free</li>
            </ul>
            <button type="button" className="profile-pkg-buy profile-pkg-buy-pro" disabled>
              Coming soon
            </button>
          </article>
        </div>

        <p className="profile-packages-footnote">
          Packages are preview-only for now. Checkout will open here when Pro packs go live. Current
          single exports still work from Save as Video.
        </p>
      </div>
    );
  }
}

export default ProfilePackages;
